declare let mxUtils: any; // available globally
declare let mxEdgeStyle: any; // available globally

export function setConnectionPoints(cell, graph) {
  const exitX = graph.getCellStyle(cell).exitX;
  const exitY = graph.getCellStyle(cell).exitY;
  const entryX = graph.getCellStyle(cell).entryX;
  const entryY = graph.getCellStyle(cell).entryY;

  const source = cell.source;
  const target = cell.target;
  let newConnectionTerminalPoint;
  let closestWaypoint: any = null;
  let xConnection: number;
  let yConnection: number;

  if (source && !exitX && !exitY) {
    newConnectionTerminalPoint = [];
    const targetPoint = cell.geometry.targetPoint;

    if (cell.geometry.points && cell.geometry.points.length > 0) {
      closestWaypoint = cell.geometry.points[0];
    }

    if (closestWaypoint) {
      if (
        closestWaypoint.x >= source.geometry.x &&
        closestWaypoint.x <= source.geometry.x + source.geometry.width
      ) {
        xConnection = Math.abs(closestWaypoint.x - source.geometry.x) / source.geometry.width;

        if (xConnection > 0.99) {
          xConnection = 0.99;
        }

        if (xConnection < 0.01) {
          xConnection = 0.01;
        }

        if (closestWaypoint.y > source.geometry.y + source.geometry.height) {
          newConnectionTerminalPoint = [xConnection, 1];
        } else {
          newConnectionTerminalPoint = [xConnection, 0];
        }
      } else if (
        closestWaypoint.y >= source.geometry.y &&
        closestWaypoint.y <= source.geometry.y + source.geometry.height
      ) {
        yConnection = Math.abs(closestWaypoint.y - source.geometry.y) / source.geometry.height;

        if (yConnection > 0.99) {
          yConnection = 0.99;
        }

        if (yConnection < 0.01) {
          yConnection = 0.01;
        }

        if (closestWaypoint.x < source.geometry.x) {
          newConnectionTerminalPoint = [0, yConnection];
        } else {
          newConnectionTerminalPoint = [1, yConnection];
        }
      }
    } else if (targetPoint) {
      if (source.geometry.x - targetPoint.x > 0) {
        newConnectionTerminalPoint = [0, 0.5];
      } else if (targetPoint.x - source.geometry.x - source.geometry.width > 0) {
        newConnectionTerminalPoint = [1, 0.5];
      } else if (source.geometry.y + source.geometry.height / 2 - targetPoint.y > 0) {
        newConnectionTerminalPoint = [0.5, 0];
      } else {
        newConnectionTerminalPoint = [0.5, 1];
      }
    } else {
      if (target.geometry.x + target.geometry.width < source.geometry.x - 0) {
        newConnectionTerminalPoint = [0, 0.5];
      } else if (target.geometry.x - 0 > source.geometry.x + source.geometry.width) {
        newConnectionTerminalPoint = [1, 0.5];
      } else if (target.geometry.y > source.geometry.y) {
        newConnectionTerminalPoint = [0.5, 1];
      } else {
        newConnectionTerminalPoint = [0.5, 0];
      }
    }

    graph
      .getModel()
      .setStyle(cell, mxUtils.setStyle(cell.style, 'exitX', newConnectionTerminalPoint[0]));
    graph
      .getModel()
      .setStyle(cell, mxUtils.setStyle(cell.style, 'exitY', newConnectionTerminalPoint[1]));
  }

  if (target && !entryX && !entryY) {
    newConnectionTerminalPoint = [];

    const sourcePoint = cell.geometry.sourcePoint;

    closestWaypoint = null;

    if (cell.geometry.points && cell.geometry.points.length > 0) {
      const lastPoint = cell.geometry.points.length - 1;

      closestWaypoint = cell.geometry.points[lastPoint];
    }

    if (closestWaypoint) {
      if (
        closestWaypoint.x >= target.geometry.x &&
        closestWaypoint.x <= target.geometry.x + target.geometry.width
      ) {
        xConnection = Math.abs(closestWaypoint.x - target.geometry.x) / target.geometry.width;

        if (xConnection > 0.99) {
          xConnection = 0.99;
        }

        if (xConnection < 0.01) {
          xConnection = 0.01;
        }

        if (closestWaypoint.y > target.geometry.y + target.geometry.height) {
          newConnectionTerminalPoint = [xConnection, 1];
        } else {
          newConnectionTerminalPoint = [xConnection, 0];
        }
      } else if (
        closestWaypoint.y >= target.geometry.y &&
        closestWaypoint.y <= target.geometry.y + target.geometry.height
      ) {
        yConnection = Math.abs(closestWaypoint.y - target.geometry.y) / target.geometry.height;

        if (yConnection > 0.99) {
          yConnection = 0.99;
        }

        if (yConnection < 0.01) {
          yConnection = 0.01;
        }

        if (closestWaypoint.x < target.geometry.x) {
          newConnectionTerminalPoint = [0, yConnection];
        } else {
          newConnectionTerminalPoint = [1, yConnection];
        }
      }
    } else if (sourcePoint) {
      if (
        sourcePoint.x + mxEdgeStyle.orthBuffer * 2 < target.geometry.x &&
        sourcePoint.y + mxEdgeStyle.orthBuffer * 2 > target.geometry.y &&
        sourcePoint.y - mxEdgeStyle.orthBuffer * 2 < target.geometry.y + target.geometry.height
      ) {
        newConnectionTerminalPoint = [0, 0.5];
      } else if (
        sourcePoint.x - mxEdgeStyle.orthBuffer * 2 > target.geometry.x + target.geometry.width &&
        sourcePoint.y + mxEdgeStyle.orthBuffer * 2 > target.geometry.y &&
        sourcePoint.y - mxEdgeStyle.orthBuffer * 2 < target.geometry.y + target.geometry.height
      ) {
        newConnectionTerminalPoint = [1, 0.5];
      } else if (sourcePoint.y > target.geometry.y) {
        newConnectionTerminalPoint = [0.5, 1];
      } else {
        newConnectionTerminalPoint = [0.5, 0];
      }
    } else {
      if (target.geometry.y + target.geometry.height < source.geometry.y) {
        newConnectionTerminalPoint = [0.5, 1];
      } else if (source.geometry.y + source.geometry.height < target.geometry.y) {
        newConnectionTerminalPoint = [0.5, 0];
      } else if (source.geometry.x > target.geometry.x) {
        newConnectionTerminalPoint = [1, 0.5];
      } else {
        newConnectionTerminalPoint = [0, 0.5];
      }
    }

    graph
      .getModel()
      .setStyle(cell, mxUtils.setStyle(cell.style, 'entryX', newConnectionTerminalPoint[0]));
    graph
      .getModel()
      .setStyle(cell, mxUtils.setStyle(cell.style, 'entryY', newConnectionTerminalPoint[1]));
  }
}
